
(function() {
    var BrandRefinement = function() {
        var brandRefinement = this;

        var brandJsonParam = '_jsonRefinements=Brand';
        var topBrandsLimit = 32;
        var numColumns = 4;
        var brandRefinements;
        var brandModalLoaded = false;
        var applyFilterLocation = false;
        var isMultiSelect = false;
        
        var $anchor = $('.refinementMenu[data-dimension="Brand"] .refinementMenuMoreLink');
        var $modal = $('#brand-refinement-modal');
        var $modalBody = $modal.find('.modal-body');
        var $modalFooter = $modal.find('.modal-footer');
        var $modalLoading = $modal.find('.loading-indicator');
        var $modalSubmit = $modal.find('.btn');

        var listen = function() {
            $anchor.click(showRefinementsModal);
            $modalSubmit.click(applyFilter);
        };

        var showRefinementsModal = function(e) {
            $modal.modal('show');

            if (brandModalLoaded) { return; }

            var href = $anchor.data('href');
            getRefinementData(href, showRefinements);

            e.stopPropagation();
            return false;
        };

        var showRefinements = function(refinements) {
            brandRefinements = {};

            // divide the brands up into sections
            brandRefinements[ 'TOP BRANDS' ] = [];
            $.each(refinements, function(i, refinement) {
                if (i < topBrandsLimit) {
                    brandRefinements[ 'TOP BRANDS' ].push(refinement);
                }

                var section = refinement.properties.label.toUpperCase().substr(0, 1);
                if (!isNaN(section)) { section = '0-9'; }

                if (!brandRefinements[ section ]) {
                    brandRefinements[ section ] = [];
                }
                brandRefinements[ section ].push(refinement);
            });

            brandRefinements[ 'TOP BRANDS' ].sort(sortRefinementsByLabel);

            // use brand sections to build menu
            var menuHTML = getMenuHTML();
            $modalBody.html(
                $('<div>')
                    .addClass('brand-buttons')
                    .html(menuHTML)
           );

            $modalBody.find('.brand-buttons button').each(function(i, button) {
                $(button).click(function(e) {
                    selectMenuButton($(button));

                    e.stopPropagation();
                    return false;
                });
            });

            $modalBody.append('<div class="brand-refinements position-relative"></div>');
            $modalLoading.hide();

            $modalBody.find('button.top-brands').click();
        };

        var getMenuHTML = function() {
            var html = [];

            var sections = Object.keys(brandRefinements).sort(sortSections);
            $.each(sections, function(i, label) {
                var $button = $('<button>');
                $button.addClass('brand-letter');
                $button.html(label);
                if (label === 'TOP BRANDS') { $button.addClass('top-brands'); }

                html.push($button[ 0 ].outerHTML)
            });

            return html.join('');
        };

        var selectMenuButton = function($button) {
            var label = $button.text().trim();
            var refinements = brandRefinements[ label ];
            
            if (!refinements) { refinements = []; }

            $modalBody.find('button')
                      .removeClass('button-selected');
            $button.addClass('button-selected');

            updateRefinements(refinements);
        };

        var updateRefinements = function(refinements) {
            var $refinements = $modalBody.find('.brand-refinements');
            $refinements.html('');

            $refinements.append(
                '<div class="loading-indicator-overlay position-absolute d-none text-center">'
              + '<i class="fa fa-circle-o-notch fa-spin mt-3"></i>'
              + '</div>'
            );

            $.each(refinements, function(i, refinement) {
                var $refinementLabel = $('<span>');
                $refinementLabel.addClass('refinementLabel')
                                .html(refinement.properties.label);

                var $refinementCount = $('<span> ');
                $refinementCount.addClass('refinementCount')
                                .html(Number(refinement.count).toLocaleString());

                var $refinement = $('<a>');
                if (isMultiSelect || refinement.multiSelect) {
                    isMultiSelect = true;

                    $refinement = $('<label>');

                    var $checkbox = $('<input>');
                    $checkbox.prop('type', 'checkbox')
                    if (   refinement.properties
                        && refinement.properties.selected
                        && refinement.properties.selected == 'true'
                       ) {
                        $checkbox.prop('checked', true);
                    }
                    $refinement.append($checkbox);
                    $refinement.change(checkBoxChanged);
                }

                var href = fixNavState(
                    refinement.navigationState,
                    [] // remove params
                );

                $refinement.addClass('filter')
                           .prop('href', href)
                           .data('href', href)
                           .append($refinementLabel)
                           .append($refinementCount);
                $refinements.append($refinement);
            });

            if (isMultiSelect) {
                $modalFooter.show();
            }
        };

        var checkBoxChanged = function(e) {
            var $checkbox = $(this);

            toggleLoading(true);
            applyFilterLocation = $checkbox.data('href');
            $modalBody.find('.loading-indicator-overlay').removeClass('d-none');
            getRefinementData(applyFilterLocation, function(refinements) {
                var $selectedMenuButton = $modalBody.find('button.button-selected');
                selectMenuButton($selectedMenuButton);
                toggleLoading(false);
                showRefinements(refinements);
                $modalBody.find('.loading-indicator-overlay').addClass('d-none');
            });
        };

        var applyFilter = function() {
            if (applyFilterLocation) {
                var href = fixNavState(
                    applyFilterLocation,
                    [ '_jsonRefinements', 'showMoreIds' ] // remove params
                );
                window.location = href;
            }
            else {
                $modal.modal('hide');
            }
        };

        var getRefinementData = function(url, callback) {
            if (url.match(/\?/)) {
                url += '&' + brandJsonParam;
            }
            else {
                url += '?' + brandJsonParam;
            }

            $.getJSON(url, function(data) {
                if (!data.refinements) { data.refinements = []; }
                callback(data.refinements);
            });
        };

        var toggleLoading = function(isLoading) {
            if (isMultiSelect) { $modalFooter.toggle(!isLoading); }
        };

        var sortRefinementsByLabel = function(a, b) {
            var aLabel = a.properties.label.toUpperCase();
            var bLabel = b.properties.label.toUpperCase();

            if (aLabel < bLabel) { return -1; }
            if (aLabel > bLabel) { return  1; }
            return 0;
        };

        var sortSections = function(a, b) {
            // top brands to the top
            if (a == 'TOP BRANDS') { return -1; }
            if (b == 'TOP BRANDS') { return  1; }

            if (a > b) { return  1; }
            if (a < b) { return -1; }
            return 0;
        };

        listen();
    };

    // wait until the page finishes loading to evaluate this
    registerScriptLoadCallback(function() {
        window.brandRefinement = new BrandRefinement();
    });
})();
